import { FC } from 'react';

interface UserReplyProps {
    message: string;
}
const UserReply: FC<UserReplyProps> = (props) => {
    const { message } = props;

    return (
        <div className="flex justify-end gap-4">
            <div className="max-w-[90%] px-4 py-3 bg-[#F0F3F9] border border-grayscale-200 dark:bg-[#20262d] shadow-[0px_1px_2px_rgba(40,52,82,0.02)] rounded-xl rounded-br-none">
                <div className="text-sm break-words whitespace-pre-wrap">{message}</div>
            </div>
        </div>
    );
};

export default UserReply;
